import React, { Component } from 'react';
import { Row, Col, Tab, FormControl, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { appConstantsSocket } from '../../_constants';
import userIcon from "../../images/userIcon.png"
import {
    chatUserListAction,
    getCompanyChatAction,
    chatUserListSearchAction,
    getCompanyChatSearchAction, 
    forwardChatAction,
    readChatAction,
    unreadChatAction,
    chatBlockAction,
    chatUnBlockAction,
    getChatList
} from "../../actions/Chat"

var $ = require("jquery");
let endUserChat = false;
let endUserList = false;

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ChatUserList: [],
            activeUser: [],
            ReadchatCount: [],
            activeCount: 0,
            chatCount: 0,
            actionId: '',
            forwardChatId: '',
            chatPage: 0,
            userPage: 0,
            showMenu: false,
            chatUSerListStatus: false,
            userId: "",
            userData: JSON.parse(localStorage.getItem('userData'))
        };

        this.showMenu = this.showMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.userBlock = this.userBlock.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this)
        let _this = this

        appConstantsSocket.socket.on('receivedMessage', async function(newChat) {

            if (newChat.reciverId === _this.state.activateUser) {
                let ChatUserList = _this.state.ChatUserList;
                var index = ChatUserList.findIndex(p => p.userId === _this.state.activateUser)
                if (index !== -1) {
                    var val1 = ChatUserList[index];
                    val1.chatData = newChat;
                    ChatUserList.splice(index, 1);
                    ChatUserList.unshift(val1);
                    _this.setState({
                        ChatUserList: ChatUserList
                    })
                }
                let getChatHistory = _this.state.getChatHistory;
                getChatHistory.push(newChat);
                _this.setState({ getChatHistory: getChatHistory }, function() {
                    var objDiv = document.getElementById("chat_list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                });

            } else {

                let ChatUserList = _this.state.ChatUserList;
                var indexofUser = 0;
                if (ChatUserList.length > 0) {
                    indexofUser = ChatUserList.findIndex(userIndex => userIndex.userId === newChat.senderId)
                }
                if ((indexofUser === -1) || (ChatUserList.length === 0)) {
                    newChat.userType = _this.state.userData && _this.state.userData.userType
                    appConstantsSocket.socket.emit('getUserDetail', newChat);
                    appConstantsSocket.socket.on('receivedUserDetail', function(newChatUser) {
                        ChatUserList.unshift(newChatUser.data[0]);
                        _this.setState({
                            ChatUserList: ChatUserList
                        })
                    });

                } else {
                    var val2 = ChatUserList[indexofUser];
                    val2.chatData = newChat
                    val2.chatCount = val2.chatCount + 1;
                    ChatUserList.splice(indexofUser, 1);
                    ChatUserList.unshift(val2);
                    _this.setState({
                        ChatUserList: ChatUserList
                    })
                    if (newChat.senderId === _this.state.activateUser) {
                        let getChatHistory = _this.state.getChatHistory;
                        getChatHistory.push(newChat);
                        _this.setState({ getChatHistory: getChatHistory });
                    }
                }
            }

            if (newChat.reciverId === _this.state.activateUser) {
                var objDivChaList = document.getElementById("chat_list");
                objDivChaList.scrollTop = objDivChaList.scrollHeight;
            }
            setTimeout(function() {
                var objDiv = document.getElementById("chat_user_list_box");
                objDiv.scrollTop = 0;

            }, 300);
        });

        appConstantsSocket.socket.on('receivedchatBlock', function(chatUser) {

            let ChatUserList = _this.state.ChatUserList;
            var index = ChatUserList.findIndex(userIndex => userIndex.userId === chatUser.data[0].userId);
            if (index !== -1) {
                ChatUserList[index] = chatUser.data[0];
            } else {
                ChatUserList.unshift(chatUser.data[0]);
            }
            _this.setState({
                showMenu: false,
                ChatUserList: ChatUserList
            })
        });

        $(document).ready(function() {
            $('#chat_list').scroll(function() {
                if ($("#chat_list").scrollTop() === 0) {
                    let chatPage = _this.state.chatPage + 1;
                    _this.state.activeNew = false;
                    _this.setState({ chatPage: chatPage, activeNew: false });

                }
            });

            $('#chat_user_list_box').scroll(function() {
                if (($(this).scrollTop() + $(this).innerHeight()) <= $(this)[0].scrollHeight) {
                    let userPage = _this.state.userPage + 1;
                    _this.setState({ userPage: userPage, chatUSerListStatus: true });
                    if (endUserList === false) {
                        const params2 = {
                            limit: 20,
                            offset: userPage,
                        }
                        if (_this.state.userData && _this.state.userData.userType === "user") {
                            _this.props.getCompanyChatAction(params2);
                        } else {
                            _this.props.chatUserListAction(params2);
                        }
                    }
                }
            });
        });
    }

    componentDidMount() {
        const params1 = {
            limit: 20,
            userPage: 0,
        }
        this.setState({
            chatUSerListStatus: true
        })
        if (this.state.userData && this.state.userData.userType === "user") {
            this.props.getCompanyChatAction(params1);
        } else {
            this.props.chatUserListAction(params1);
        }
    }

    componentWillReceiveProps(nextProps) {
        switch (nextProps.chatRequestType) {
            case "ChatList":
                if (nextProps.chatUserListData && nextProps.chatUserListData.list && nextProps.chatUserListData.list.data && nextProps.chatUserListData.list.data.length > 0 && this.state.chatUSerListStatus) {
                    let UserList = this.state.ChatUserList;
                    UserList = UserList.concat(nextProps.chatUserListData.list.data)
                    this.setState({
                        chatUSerListStatus: false,
                        ChatUserList: UserList
                    })
                }
                break;
            case "ChatListSearch":
                if (nextProps.chatUserListData && nextProps.chatUserListData.list && nextProps.chatUserListData.list.data && Array.isArray(nextProps.chatUserListData.list.data)) {
                    let chatUserList = nextProps.chatUserListData.list.data
                   // chatUserList = [];
                    this.setState({
                        ChatUserList: chatUserList
                    })
                }
                break;

            case "chatHistory":
                if (nextProps.chatUserListData.list) {
                    let chatUserListHistory = nextProps.chatUserListData.list
                    let chatArr = [];
                    for (var x in chatUserListHistory) {
                        chatArr.unshift(chatUserListHistory[x]);
                    }
                    appConstantsSocket.socket.emit('getchatCount', { id: this.state.userData._id });

                    this.setState({
                        getChatHistory: chatArr
                    })
                }
                break;
            case "ChateReadStatus":
                if (nextProps.chatUserListData && nextProps.chatUserListData.statusCode === 200) {
                    var ChatUserList = this.state.ChatUserList
                    var index = ChatUserList.findIndex(userIndex => userIndex.userId === this.state.activateUser)
                    if (index !== -1) {
                        ChatUserList[index].chatCount = 0;
                    }
                    this.setState({
                        ChatUserList: ChatUserList
                    })
                }
                break;
            case "blockUser":
                if (nextProps.chatUserListData && nextProps.chatUserListData.statusCode === 200) {
                    let dataReq = {
                        type: "chatBlock",
                        senderId: this.state.userData._id,
                        reciverId: this.state.actionId,
                        userType: this.state.userData && this.state.userData.userType
                    }
                    appConstantsSocket.socket.emit('chatBlock', dataReq);
                }
                break;
            case "UnblockUser":
                if (nextProps.chatUserListData && nextProps.chatUserListData.statusCode === 200) {
                    // let _this = this;
                    let dataReq = {
                        type: "chatBlock",
                        senderId: this.state.userData._id,
                        reciverId: this.state.actionId,
                        userType: this.state.userData && this.state.userData.userType
                    }
                    appConstantsSocket.socket.emit('chatBlock', dataReq);
                }
                break;
            default:
                return true;
        }
    }

    showMenu = (id) => {
        if (this.state.showMenu === id) {
            this.setState({
                showMenu: false
            })
        } else {
            this.setState({
                showMenu: id
            })
        }
        // this.setState({ showMenu: true }, () => {
        //     document.getElementById(event).addEventListener('click', this.closeMenu);
        // });
    }

    closeMenu() {
        this.setState({ showMenu: false }, () => {
            document.removeEventListener('click', this.closeMenu);
        });
    }

    sendMessageAction() {
        var message = document.getElementById('message').value;
        if (message !== '') {
            let chatData = {
                message: message,
                senderId: this.state.userData._id,
                reciverId: this.state.activateUser,
            };
            appConstantsSocket.socket.emit('sendMessage', chatData);
            document.getElementById('message').value = '';
            setTimeout(function() {
                var objDiv = document.getElementById("chat_list");
                objDiv.scrollTop = objDiv.scrollHeight;

            }, 300);
        }
    }

    searchTextFillter = async (e) => {
        e.preventDefault();
        var reqObj = {
            limit: 20,
            userPage: 0,
        }
        if (e.target.value) {
            reqObj.search = e.target.value;
            this.setState({
                reqObj: reqObj
            })
        }
        if (this.state.userData && this.state.userData.userType === "user") {
            this.props.getCompanyChatSearchAction(reqObj);
        } else {
            this.props.chatUserListSearchAction(reqObj);
        }
    }

    sendMessage(e) {
        this.sendMessageAction();
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.sendMessageAction();
        }
    }

    showImage(proFileImage) {
        if (proFileImage) {
            let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + proFileImage;
            return fileUrl;
        } else {
            return <span>-</span>
        }
    }

    activateUser(userId, chatCount, e) {

        endUserChat = false;
        endUserList = false;
        this.setState({ isUptNewChatUser: true, chatPage: 0, userPage: 0, GetPatientChat: [], showMenu: "", activeNew: true, activeNewChat: false });

        const params = {
            /* limit:10,
             skip:this.state.chatPage,*/
            reciverId: userId,
        }
        this.props.readChatAction({ senderId: userId });
        this.props.getChatList(params);
        let activeUser = this.state.activeUser;
        for (let i in activeUser) {
            if (activeUser[i] !== userId)
                activeUser[i] = false;
        }

        activeUser[userId] = true;
        this.setState({ activeUser: activeUser, activateUser: userId });

        setTimeout(function() {
            var objDiv = document.getElementById("chat_list");
            objDiv.scrollTop = objDiv.scrollHeight;

        }, 300);
    }

    userBlock = (userId, type) => {
        this.setState({
            actionId: userId
        })
        if (type === "Block") {
            this.props.chatBlockAction({ blockId: userId })
        }
        if (type === "Unblock") {
            this.props.chatUnBlockAction({ unblockId: userId })
        }
    }

    render() {
        const { userData } = this.state;
        let ChatUserList = '';
        let userChatHistory = '';
        let activeUserFirstName = '';
        let chatInput = '';
        let subMenuName = 'Block';
        let optionBlock = false;
        let messageBlockBy = "";
        let noChatFound = <b style={{margin:'37%'}}>No Messages found!</b>;

         
        if (this.state.ChatUserList && this.state.ChatUserList.length) {
            ChatUserList = this.state.ChatUserList.map((key, i) => {
                optionBlock = false;
                if (key && key.blockDetail && key.blockDetail.length > 0) {
                    console.log("key", key);
                    var indexBlock = key.blockDetail.findIndex(p => p.blockId === userData._id)
                    console.log("indexBlock", indexBlock);
                    if (indexBlock >= 0) {
                        subMenuName = "You are blocked by" + key.userName;
                        optionBlock = true
                    }
                    if (key.blockDetail&&key.blockDetail[indexBlock] &&key.blockDetail[indexBlock].blockedBy === userData._id) {
                        subMenuName = "Unblock "
                    } 
                } else {
                    subMenuName = "Block"
                }
                if (key && key.userId && ( key.userId === this.state.activateUser)) {
                    activeUserFirstName = key.userName;
                    if (key && key.blockDetail && key.blockDetail.length > 0) {
                        var indexBlock = key.blockDetail.findIndex(p => p.blockId === userData._id)
                        if (indexBlock >= 0) {
                            subMenuName = "Unblock";
                            optionBlock = true
                            if (key.blockDetail[indexBlock].blockedBy === userData._id) {
                                messageBlockBy = "you've blocked " + key.userName;
                            } else {
                                subMenuName = "You are blocked by " + key.firstName;
                                messageBlockBy = "You can't reply to this conversation";
                            }
                        }
                    }


                    chatInput = <div>
                                {!optionBlock&&
                                    <div  className="row chatinput align-msg">
                                        <Col md={10} sm={8} style={{marginTop:'10px'}}>
                                            <FormControl placeholder="Type Message.." type="text" name="message" id="message" onKeyPress={this._handleKeyPress} />
                                        </Col>
                                        <Col md={2} sm={2}style={{marginTop:'10px'}}>
                                            <Button className="btn btn-primary pull-right"  onClick={e => { this.sendMessage(e); }}>Send</Button>
                                        </Col>
                                    </div>    
                                }{optionBlock&& 
                                    <Col md={12} style={{marginTop:'10px',color:'blue'}}>{messageBlockBy}</Col>
                                }
                            </div>
                }
                return (
                    <div className={this.state.activeUser[key.userId] && this.state.isUptNewChatUser ? 'single_chat_list  active' : 'single_chat_list  deactive'} >
                        <span onClick={this.activateUser.bind(this,key.userId,key.chatCount)}>
                        <span className="chat_profile">
                            <img src={key.userImage?this.showImage(key.userImage):userIcon} alt="new" className="rounded" scale={4}  vertical={0} horizontal={5} />
                        </span>
                        <div className={this.state.activeUser[key.userId] && this.state.isUptNewChatUser ? 'chat_user_list chat_msg active' : 'chat_user_list chat_msg deactive'} data-id="15">
                            <span className="chat-apa"  data-id="15" chat-id={key.chatId} >
                                <span className="name">{key.userName}</span>
                                <span className="msg">{key.chatData && key.chatData[0]?(key.chatData && key.chatData[0]&& key.chatData[0].message):key.chatData && key.chatData.message}</span>
                                <span className="msgCount" style={{display:key.chatCount > 0 ? 'block' : 'none'}}>{key.chatCount}</span>
                            </span>
                        </div>

                        </span>
                           <span className="Chat_rightpoint_btns" onClick={(e)=>this.showMenu(key.userId)}></span>
                                <div className="menu">
                                {this.state.showMenu && this.state.showMenu===key.userId &&
                                    <span id={key.userId} name={key.userId} onClick={this.userBlock.bind(this,key.userId,subMenuName)}>{subMenuName}</span>
                                }


                        </div>
                    </div>
                )
            })
            noChatFound = '';
        }

        if (this.state.getChatHistory && this.state.getChatHistory.length) {

            userChatHistory = this.state.getChatHistory.map((key, i) => {
                let selfChat = '';
                let float = '';
                if (key.reciverId === this.state.activateUser) {
                    selfChat = 'self-chat';
                    float = 'float-right';
                } else {
                    selfChat = 'patient-chat';
                    float = 'float-left';
                }

                var time = new Date(key.createdAt);
                var date = new Date(time);
                var dateTime = date.getHours() + ':' + date.getMinutes();
                let senderName = '';
                let forAction = '';

                return (
                    <div className={float+" chatbox"} key={i}>
                        <small className="chatTime">{senderName}&nbsp;{dateTime.toString()}</small>
                        <div className={selfChat+" chat_user_list chat_msg"} data-id="11">
                            <span className="chat-apa" data-id="11" chat-id="20">
                                <span className="name"></span>
                                <span className="msg">{key.message}</span>
                                <span className="msgCount" style={{display:this.state.ReadchatCount[key._id] ? 'block' : 'none'}}>{key.chatCount}</span>
                            </span>
                        </div>
                        {forAction}
                    </div>
                )
            })

            setTimeout(function() {
                var forwadIcon = document.getElementsByClassName("forwadIcon");
                for (let x in forwadIcon) {
                    if (forwadIcon[x].style) {
                        forwadIcon[x].style.display = "none";
                    }
                }
            }, 500);
        }

        return (
            <Row>
                <Col md={4}>
                    <Tab.Container id="nav-with-icons" defaultActiveKey="all">
                        <div>
                            <div className="nav-container pa-chat">
                                <input className="form-control" type="text" placeholder="Search" aria-label="Search"  onChange={this.searchTextFillter.bind(this)} />
                            </div>
                            <div className="chat_list chat_list_nav chat_list_all chat-list-pa active" id="chat_user_list_box">
                                {ChatUserList}
                            </div>
                        </div>
                    </Tab.Container>
                </Col>
                <Col md={8} sm={12} className="gray_bg">
                    {this.state.activateUser&&this.state.activateUser !=="" &&
                        <div>
                            <h4 className="row chatbox_header">{activeUserFirstName}</h4>
                            <Row className="chat-wind-body">
                                <div className="scrolldivs" id="scrolldiv">
                                    {noChatFound}
                                    <div>
                                        <Col md={12}>
                                            <div className="pa_chat_window chat_list chat_list_nav chat-list-pa active"  id="chat_list">
                                                <div>{userChatHistory}</div>
                                            </div>
                                        </Col>
                                    </div>
                                </div>
                                {chatInput}
                            </Row>
                        </div>
                    }
                </Col>    
            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        chatUserListData: state.Chat.response,
        chatRequestType: state.Chat.type,
    }
}

export default withRouter(connect(mapStateToProps, {
    chatUserListAction,
    getCompanyChatAction,
    forwardChatAction,
    readChatAction,
    unreadChatAction,
    getChatList,
    getCompanyChatSearchAction,
    chatBlockAction,
    chatUnBlockAction,
    chatUserListSearchAction
})(Chat));


// WEBPACK FOOTER //
// ./src/components/Chat/Chat.js